module.exports = __webpack_public_path__ + "img/logo.530f3b93.png";